import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./EmailVerificationDeeplinkLanding.css";
import { makeVerifyEmailRequest } from "API/Auth";
import { REQUESTS } from "Util/constants";
import LoadingScreen from "Containers/Pages/Modal/modals/LoadingScreen";

const EmailVerificationDeeplinkLanding = (props) => {
  const { emailVerificationToken, email } = props;
  const dispatch = useDispatch();

  const verifyEmailRequestStatus = useSelector(
    (state) => state.stateSlice?.requests[REQUESTS.VERIFY_EMAIL]
  );

  useEffect(() => {
    makeVerifyEmailRequest(dispatch, email, emailVerificationToken);
  }, [emailVerificationToken, email, dispatch]);


  useEffect(() => {

    console.log({ verifyEmailRequestStatus });
    if (verifyEmailRequestStatus === "success") {
      console.log("Email Verified");
      setTimeout(() => {
        window.location.href = "/";
      }, 2000);
    }
  }, [verifyEmailRequestStatus]);
  return (
    <div className="email-verification-deep-link-landing-container">
      {verifyEmailRequestStatus === "loading" ? (
        <LoadingScreen />
      ) : (
        <div>
          Thanks for verifying your email! <br />
        </div>
      )}
    </div>
  );
};

export default EmailVerificationDeeplinkLanding;
